import React from "react";
import "./styles/Projects.css";

const Projects = () => {
  const projects = [
    {
      title: "internships web platform",
      description:
        "A web platform dedicated to the search for internships for students.",
      technologies: ["HTML", "CSS", "JavaScript", "Bootstrap"],
      link: "https://github.com/yassine-mili/InterniTN",
    },
    {
      title: "Project management platform for modern teams",
      description:
        "A comprehensive project management platform designed for modern teams to collaborate and manage their projects efficiently.",
      technologies: [
        "TypeScript",
        "Node.js",
        "Express.js",
        "MongoDB",
        "React",
        "TailwindCSS",
        "Socket.IO",
        "Passport.js",
        "OAuth",
      ],
      link: "https://github.com/yassine-mili/TeamFlow",
    },
    {
      title: "Patient Management System - Architecture Microservices",
      description:
        "Microservices-based patient management system with scalable services and messaging.",
      technologies: [
        "Spring Boot",
        "gRPC",
        "Kafka",
        "Spring Cloud Gateway",
        "AWS CDK",
        "Docker",
        "PostgreSQL",
        "JWT",
      ],
      link: "#",
    },
  ];

  return (
    <section id="projects" className="projects-section">
      <h2>Projects</h2>
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div key={index} className="project-card">
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            <div className="technologies">
              {project.technologies.map((tech, i) => (
                <span key={i} className="tech-tag">
                  {tech}
                </span>
              ))}
            </div>
            <a href={project.link} className="project-link">
              View Project
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
